export enum Size {
  Small = "sizeSmall",
  Medium = "sizeMedium",
  Large = "sizeLarge",
}
